import { render, staticRenderFns } from "./lrn-lookup-tool.vue?vue&type=template&id=f6205804"
import script from "./lrn-lookup-tool.vue?vue&type=script&lang=js"
export * from "./lrn-lookup-tool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports